<template>
    <div style="height: 100%;">
        <van-nav-bar
          title="作品审核"
          left-text="返回"
          left-arrow
          @click-left="historyBack"
        />
        <el-form :inline="true" size="mini">
            <el-form-item label="门店" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
                <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
                  <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-tabs v-model="active" @tab-click="handleClick" :stretch="true">
            <el-tab-pane label="作品"></el-tab-pane>
            <el-tab-pane label="头像"></el-tab-pane>
        </el-tabs>
        <van-list v-model="loading" :finished="isfinite" @load="load" finished-text="加载完成" style="height: 100%;margin-bottom: 20px;">
            <el-card class="box-card" size="mini" v-for="(item,index) in works" :key="index" style="margin-bottom: 10px;" shadow="never">
                <div slot="header" class="clearfix">
                    <div style="font-size:12px">
                        <el-button style="float: right;margin-left: 20px;" type="primary" size="mini" @click="updateStaffWorkStatus(item.id)">审核</el-button>
                        <el-button style="float: right;" type="danger" size="mini" @click="deleteStaffWorksById(item.id)">驳回</el-button>
                        {{item.storename}}:{{item.createdate.substring(0,10)}}
                        <br>
                        {{item.staffname}}:{{item.workname}}
                    </div>
                </div>
                <van-uploader :file-list="item.fileList" :max-count="item.billtype==2?1:3"/>
            </el-card>
        </van-list>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loading:false,
                active:0,
                storeid:localStorage.getItem("storeid"),
                brands:[],
                isfinite:false,
                works:[],
                billtype:1,
                curpage:0,
                pagesize:5,
            }
        },
        created:function() {
            this.getStoreInfoByStructsOpen();
            this.getStaffWorksByWorks();
        },
        methods: {
            deleteStaffWorksById(id){
                this.$dialog({
                    message:'您确定要驳回该记录吗？',
                    showCancelButton:true,
                }).then(() => {
                    this.$post("hairwork/deleteStaffWorksById",{id:id}).then(res=>{
                        if(res.sucess){
                            this.$message({message: "驳回成功",type: 'success'});
                            this.handleClick(0);
                        }
                        else{
                            this.$message({message: res.message,type: 'error'});
                        }
                    });
                });

            },
            updateStaffWorkStatus(id){
                this.$post("hairwork/updateStaffWorkStatus",{id:id}).then(res=>{
                    if(res.sucess){
                        this.handleClick(0);
                        this.$message({message: "审核成功",type: 'success'});
                    }
                    else{
                        this.$message({message: res.message,type: 'error'});
                    }
                });
            },
            handleClick(val){
                if(this.active==0){
                    this.billtype=1;
                }
                else{
                    this.billtype=2;
                }
                this.works=[];
                this.curpage=0;
                this.getStaffWorksByWorks();
            },
            getStaffWorksByWorks(){
                this.curpage++;
                this.loading=true;
                this.$post("hairwork/getStaffWorksByWorks",{storeid:this.storeid,billtype:this.billtype,curpage:this.curpage,pagesize:this.pagesize}).then(res=>{
                    this.loading=false;
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                let image=new Object();
                                let fileList=[];
                                if(val.work1){
                                    image.url=this.baseImageUrl+val.work1;
                                    image.deletable=false;
                                    fileList.push(image);
                                }
                                if(val.work2){
                                    image=new Object();
                                    image.url=this.baseImageUrl+val.work2;
                                    image.deletable=false;
                                    fileList.push(image);
                                }
                                if(val.work3){
                                    image=new Object();
                                    image.url=this.baseImageUrl+val.work3;
                                    image.deletable=false;
                                    fileList.push(image);
                                }
                                this.$set(val,"fileList",fileList);
                                this.works.push(val);
                            }
                        }
                        else{
                            this.isfinite=true;
                        }
                    }
                    else{
                        this.isfinite=true;
                        this.$message({message: res.message,type: 'error'});
                    }
                });
            },
            load(){
                this.getStaffWorksByWorks();
            },
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.handleClick();
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/hair/hairworkexamine.vue